import { DEFAULT_COLOR_SCHEME, defaultBrand, defaultTheme } from "./defaults-i_xG2F_1.js";
import { createContext, use } from "react";
//#region src/components/ThemeProvider/context.tsx
const noop = () => void 0;
const defaultContext = {
	scheme: DEFAULT_COLOR_SCHEME,
	resolvedScheme: DEFAULT_COLOR_SCHEME,
	setScheme: noop,
	brandId: defaultTheme.id,
	setBrand: noop,
	themes: [defaultTheme],
	currentTheme: defaultTheme,
	brandTheme: defaultBrand.theme
};
const ThemeContext = createContext(defaultContext);
const useTheme = () => use(ThemeContext);
/**
* TEMPORARY, kbc-ui-internal: whether the subtree renders the argo design language.
*
* - kbc-ui provides `false` for legacy brands/surfaces (its `AppThemeProvider`).
* - `ThemeProvider` never sets it — argo is independent of the brand.
* - Delete it and `useArgoDesign` once kbc-ui's chrome is migrated.
*/
const ArgoDesignContext = createContext(true);
const useArgoDesign = () => use(ArgoDesignContext);
//#endregion
export { ArgoDesignContext, ThemeContext, useArgoDesign, useTheme };

//# sourceMappingURL=context-U293r3v-.js.map